<template>
    <div>
        <div class="rptList" v-for="noteWeek in noteList">
            <div class="maincontent el-row">
<!--                <div class="left el-col el-col-1">-->
<!--                    <div class="circleName">-->
<!--                        <div class="name" style="background: rgb(255, 127, 0);">-->
<!--                            <span>{{noteWeek.summary}}</span></div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="el-col el-col-23">
                    <div class="right">
                        <div class="right_header el-row">
                            <div class="el-col el-col-10">
                                <div class="titleLeft">
                                    <div class="titleTime">
                                        <div class="titleDate">
                                            <span>{{noteWeek.year}}-</span> <span
                                                class="timeday">第{{noteWeek.summary}}</span>
                                        </div>
                                        <div class="titleWeek">({{noteWeek.start}}~{{noteWeek.end}})</div>
                                    </div>
                                </div>
                            </div>
<!--                            <div class="titleRight">-->

<!--                            </div>-->
                        </div>
                        <NoteCard :plan=noteWeek.plan :planTypeName="planTypeName" :planType="planType" :startDate="noteWeek.year+'/'+noteWeek.start" :endDate="noteWeek.year+'/'+noteWeek.end"></NoteCard>
                        <div class="line10px"></div>
                    </div>
                </div>
            </div>
        </div>
        <div style="text-align: center;padding: 10px">
            <a @click="loadMoreWeekNotes">
                <i class="fa fa-arrow-circle-o-down" style="margin-right: 5px"></i>加载更多周报</a>
        </div>
    </div>
</template>

<script>
    import NoteCard from '@/apps/plan/mobile_page/sub_components/cards/note_mobile_card.vue'
    import planApi from '@/api/plan/plan_api.js'

    export default {
        name: "week_notes",
        components: {NoteCard},
        data: function () {
            return {
                theMonth: (new Date()),
                planTypeName: '周',
                planType:'week',
                my_plans: [],
                noteList: []
            }
        },
        methods: {
            loadMoreWeekNotes: function () {
                let jsDate = this.theMonth.getFullYear() + '-' + (this.theMonth.getMonth() + 1) + '-' + this.theMonth.getDate()
                let ksDate = this.theMonth.getFullYear() + '-' + (this.theMonth.getMonth()) + '-01'
                if (this.theMonth.getMonth() == 0)
                    ksDate = (this.theMonth.getFullYear() - 1) + '-' + 12 + '-01'
                let args = {
                    'sdate': ksDate,
                    'edate': jsDate,
                    'ptype': 'week',
                }
                planApi.get_my_plans_by_date(args).then((res) => {
                    this.my_plans = res.data;

                    this.getWeeksWithYearAndMonth()
                    let month = this.theMonth.getMonth()
                    let years = this.theMonth.getFullYear()
                    if (month == 0) {
                        years = years - 1
                        month = 12
                    }
                    this.theMonth = new Date(years + '-' + month + '-01')
                })

            },
            compare: function (obj1, obj2) {
                let val1 = obj1.weekIdx;
                let val2 = obj2.weekIdx;
                if (val1 < val2) {
                    return 1;
                } else if (val1 > val2) {
                    return -1;
                } else {
                    return 0;
                }
            },
            weekPlan: function (start) {
                let p = []
                for (var i = 0; i < this.my_plans.length; i++) {
                    if (this.my_plans[i].plan_type === "week" && (new Date(this.my_plans[i].open_time)).getFullYear() == start.getFullYear() && (new Date(this.my_plans[i].open_time)).getMonth() == start.getMonth() && (new Date(this.my_plans[i].open_time)).getDate() == start.getDate()) {
                        p.push(this.my_plans[i])
                        break
                    }
                }
                return p.length > 0 ? p[0] : null
            },
            getWeek: function (z) {//参数z是"2018-05-07 15:12:36"或者"2018/05/07 15:12:36"
                let day11 = new Date(z);
                day11.setMonth(0);
                day11.setDate(1);
                day11.setHours(0);
                day11.setMinutes(0);
                day11.setSeconds(0);//到这里就得到该年的一月一日

                let day11mill = day11.getTime();
                let ori_day = day11.getDay();//该年的一月一日是星期几
                let fill1 = 0;//与星期日相隔的毫秒数
                if (ori_day !== 0) {
                    fill1 = ori_day * 60 * 60 * 24 * 1000;
                }

                let now = Date.parse(z);
                now = new Date(now);
                now.setHours(0);
                now.setMinutes(0);
                now.setSeconds(0);
                let nowmill = now.getTime();
                let now_day = now.getDay();
                let fill2 = 0;
                if (now_day !== 0) {
                    fill2 = (7 - now_day) * 60 * 60 * 24 * 1000;
                }

                let cha2 = (nowmill - day11mill + fill1 + fill2) / (60 * 60 * 24 * 1000);
                let week = Math.ceil(cha2 / 7);
                if (week < 10) {
                    week = "0" + week;
                }
                return week;
            },
            addDays(theDateStr, days) {
                let d = new Date(theDateStr)
                d.setMilliseconds(d.getMilliseconds() + (days * 24 * 60 * 60 * 1000));
                return d;
            },
            getWeeksWithYearAndMonth() {
                let month = this.theMonth.getMonth() + 1;
                let years = this.theMonth.getFullYear();
                let weeks = [];
                let month2 = parseInt(month) - 1;
                let myDate = new Date(years, month2, 1);
                let firstDay = myDate.getDay();
                let myDate2 = new Date(years, month, 0);
                let days = myDate2.getDate();
                let firstMonday = '';
                let lastDay = '';
                if (firstDay - 1 == 0) {
                    firstMonday = firstDay;
                    lastDay = days;
                } else {
                    firstMonday = 7 - firstDay + 2;
                    lastDay = days - (7 - firstDay + 1);
                }
                let weeksCount = Math.floor(lastDay / 7);
                let startIdx = 0;
                if (firstDay - 1 != 0) {
                    let week = new Object();
                    let startWeek = this.addDays(years + '/' + month + '/' + 1, -(7 - firstMonday + 1))
                    week.year = startWeek.getFullYear()
                    week.start = (startWeek.getMonth() + 1) + '/' + startWeek.getDate();
                    week.end = month + '/' + (firstMonday - 1);
                    week.summary = this.getWeek(years + '/' + month + '/' + 1) + '周';
                    week.value = 1;
                    week.plan = this.weekPlan(new Date(startWeek.getFullYear() + '/' + week.start));
                    week.weekIdx = startIdx
                    weeks.push(week);
                    startIdx = 1;
                }

                let weekth = '';
                for (let i = 0; i < weeksCount; i++) {
                    weekth = i + 1 + startIdx
                    let week = new Object();
                    let dtStart = new Date(years + '/' + month + '/' + (firstMonday + 7 * i))
                    if (dtStart <= (new Date())) {
                        week.year = years
                        week.start = month + '/' + (firstMonday + 7 * i);
                        week.end = month + '/' + ((firstMonday + 7 * i) + 7 - 1);
                        week.summary = this.getWeek(years + '/' + month + '/' + (firstMonday + 7 * i)) + '周 ';
                        week.value = (i + 1 + startIdx).toString();
                        week.weekIdx = i + 1 + startIdx
                        week.plan = this.weekPlan(new Date(years + '/' + week.start));
                        weeks.push(week);
                    }
                }
                weeks.sort(this.compare)
                for (let i = 0; i < weeks.length; i++) {
                    this.noteList.push(weeks[i]);
                }
                return weeks;
            }
        },
        computed: {},
        mounted() {
            this.loadMoreWeekNotes()
        }
    }
</script>

<style scoped>
    .circleName {
        display: inline-block;
        width: 100%;
    }

    .circleName .name {
        border-radius: 100px;
        float: left;
        margin-left: 10px;
        display: inline-block;
        text-align: center;
        color: #fff;
        font-size: 12px;
        margin-bottom: 15px;
        width: 40px;
        height: 40px;
        background: #ff7f00;
        line-height: 40px;
    }

    .rptList {
        width: 96%;
        margin-left: 2%;
        display: inline-block;
        background: #eee;
    }

    .rptList .maincontent {
        width: 100%;
        border: 1px solid #ddd;
        background: #fff;
        margin-bottom: 3px;
        padding-bottom: 15px;
    }

    .rptList .right {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .rptList .left {
        margin-top: 15px;
    }

    .el-row {
        margin-bottom: 3px;
        padding-bottom: 15px;
    }

    .rptList .right .right_header {
        display: inline-block;
        border-bottom: 1px solid #ddd;
        width: 98%;
        margin-left: 1%;
    }

    .rptList .right .right_header .titleLeft {
        float: left;
        font-size: 16px;
        margin-top: 24px;
    }

    .rptList .right .right_header .titleLeft .titleTime {
        float: left;
        line-height: 22px;
    }

    .rptList .right .right_header .titleLeft .titleTime .titleDate {
        float: left;
    }

    .rptList .right .right_header .titleLeft .titleTime .titleDate .timeday {
        color: #390;
    }

    .rptList .right .right_header .titleLeft .titleTime .titleWeek {
        float: left;
        margin-left: 6px;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 2px;
    }

    .rptList .right .right_header .titleRight {
        float: right;
        height: 40px;
        line-height: 40px;
        margin-top: 10px;
        margin-right: 20px;
    }

    .el-row:after, .el-row:before {
        display: table;
    }

    .el-col-1, .el-col-23, .el-col-10 {
        float: left;
        box-sizing: border-box;
    }

    .el-col-1 {
        width: 4.16667%;
    }

    .el-col-23 {
        width: 95.83333%;
    }

    .el-col-10 {
        width: 100%;
    }

    .el-col {
        padding-left: 10px;
        padding-right: 10px;
    }


</style>